import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { compose } from "redux";
import { withStyles } from "components/common";
import { gql } from "apollo-boost";
import { Link } from "react-router-dom";

const FraudDataBox = ({ user }) => {
  const meta = JSON.parse(user.metadata || "{}");
  let bank_user_ids = [];
  let address_user_ids = [];
  let phone_user_ids = [];
  let uids = [];
  if (meta) {
    bank_user_ids = meta.bank_shared_with || [];
    address_user_ids = meta.address_shared_with || [];
    phone_user_ids = meta.phone_shared_with || [];
    uids = [
      ...new Set([...bank_user_ids, ...address_user_ids, ...phone_user_ids])
    ];
  }
  const skip = !meta;
  const { loading, error, data } = useQuery(
    QUERY,
    {
      variables: { ids: uids }
    },
    skip
  );
  let users;
  if (meta && !error && !loading) {
    users = data.users
      .filter(u => u.id !== user.id)
      .map(u => {
        let dupes = `${bank_user_ids.includes(parseInt(u.id)) ? "dup_bank" : ""}
        ${address_user_ids.includes(parseInt(u.id)) ? "dup_addr" : ""}
        ${phone_user_ids.includes(parseInt(u.id)) ? "dup_phone" : ""}`;

        dupes = dupes.trim() === "" ? "" : `[${dupes}]`;
        const limit_str =
          u.credit && u.credit.credit_limit
            ? `for $${u.credit.credit_limit}`
            : "";
        const colors = {
          approved: "text-green-600",
          preapproved: "text-gray-800",
          pending: "text-blue-600",
          rejected: "text-red-600"
        };
        const styl = u.application_status ? colors[u.application_status] : "";
        const cardStatus =
          u.card && u.card.status ? `, card ${u.card.status}` : "";
        return (
          <Link
            className={`${styl} block`}
            key={u.id}
            to={{
              pathname: `/supportal/user?email=${encodeURIComponent(u.email)}`
            }}
            target="_blank"
          >
            {`${u.email} (${u.first_name} ${u.last_name}) - ${u.application_status} ${limit_str} ${cardStatus}, ${dupes}`}
          </Link>
        );
      });
  }
  return (
    <div className="fraud-data my-5">
      <h1 className="text-2xl font-title mb-2 font-light">
        Fraud Data (related users with duplicate data)
      </h1>
      {!meta ? (
        <>No Data (no fraud)</>
      ) : error ? (
        <>Error...</>
      ) : loading ? (
        <>Loading...</>
      ) : (
        <div>{users}</div>
      )}
    </div>
  );
};

const QUERY = gql`
  query Users($ids: [ID]) {
    users(ids: $ids) {
      email
      first_name
      last_name
      application_status
      total_spend
      tags
      metadata
      credit {
        credit_limit
      }
      card {
        status
        activated
        last_four_digits
      }
      id
    }
  }
`;

export default compose(withStyles)(FraudDataBox);
